import { envVars } from '@/config';
import { histories, presidentDetail, presidents } from '@/mocks';
import type { IGetHistoryReq, IGetHistoryRes, IGetPresidentByIdReq, IGetPresidentByIdRes } from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchCustomBaseQuery } from '../fetcher';

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery: fetchCustomBaseQuery({
    baseUrl: envVars.backendUrl,
    mock: false,
  }),
  tagTypes: ['history'],
  endpoints: (builder) => ({
    getHistory: builder.query<IGetHistoryRes['data'], IGetHistoryReq>({
      query: ({ locale, page = 1 }) => ({
        url: `/cups-and-fpf/history?locale=${locale}&page=${page}`,
        isProtected: false,
        method: 'get',
        forceMock: false,
        mockData: {
          message: 'History fetched Successfully',
          data: {
            history_page: histories[0],
            presidents: presidents.slice((page - 1) * 15, page * 15),
            pagination: {
              current_page: page,
              from: (page - 1) * 15 + 1,
              last_page: Math.ceil(presidents.length / 15),
              per_page: 15,
              to: Math.min(page * 15, presidents.length),
              total: presidents.length
            }
          },
        },
      }),
      transformResponse: (response: IGetHistoryRes) => response.data ?? {},
    }),
    getPresidentDetail: builder.query<IGetPresidentByIdRes['data']['president'], IGetPresidentByIdReq>({
      query: ({ presidentId }) => ({
        url: `/cups-and-fpf/president/${presidentId}`,
        isProtected: false,
        forceMock: false,
        method: 'get',
        mockData: {
          message: 'President fetched Successfully',
          data: { president: presidentDetail },
        },
      }),
      transformResponse: (response: IGetPresidentByIdRes) => response.data?.president ?? {},
    }),
  }),
});

export const { useGetHistoryQuery } = historyApi;
